import React from "react";

function AddQuantity(props) {
  return <button onClick={props.handleClick}>Add Cart</button>;
}

export default AddQuantity;
